import React, { useState } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, CircularProgress,
} from '@material-ui/core';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { VIDEO_API_BASE } from '../../../UrlFiles/UrlFiles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      background: theme.brand,
      color: 'white',
      '&:hover': { background: '#600101' },
    },
  })
);

export default function EndCallButton(props: { className?: string }) {
  const classes = useStyles();
  const { room } = useVideoContext();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [checking, setChecking] = useState(false);
  const [isLastRecruiter, setIsLastRecruiter] = useState(false);
  const [ending, setEnding] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const role = params.get('role');
  const joinToken = params.get('join_token');
  const isNewFlow = !!role && !!joinToken;
  const isRecruiter = role === 'recruiter';

  const roomName = room?.name || window.location.pathname.split('/room/')[1];

  const handleClick = async () => {
    if (!isNewFlow || !isRecruiter) {
      room!.disconnect();
      return;
    }

    setChecking(true);
    try {
      const res = await fetch(`${VIDEO_API_BASE}/video/connected-recruiters/${roomName}?join_token=${joinToken}`);
      const data = await res.json();
      setIsLastRecruiter(data.connected_recruiters <= 1);
    } catch {
      setIsLastRecruiter(false);
    } finally {
      setChecking(false);
      setConfirmOpen(true);
    }
  };

const handleDisconnect = async (endForAll: boolean) => {
  setEnding(true);
  if (endForAll && joinToken) {
    try {
      await fetch(`${VIDEO_API_BASE}/video/end-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ join_token: joinToken }),
      });
    } catch (e) {
      // console.error('end-session failed', e);
    }
  }
  room!.disconnect();
  window.parent.postMessage(
  { type: 'INTERVIEW_DISCONNECTED', endedForAll: endForAll },
  '*'
);
  setConfirmOpen(false);
  setEnding(false);
};


  return (
    <>
      <Button
        onClick={handleClick}
        className={clsx(classes.button, props.className)}
        data-cy-disconnect
        disabled={checking}
        startIcon={checking ? <CircularProgress size={14} color="inherit" /> : undefined}
      >
        {checking ? 'Checking…' : 'Disconnect'}
      </Button>

      <Dialog open={confirmOpen} onClose={() => !ending && setConfirmOpen(false)}>
        <DialogTitle>
          {isLastRecruiter ? 'End Interview for Everyone?' : 'Leave Interview?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {isLastRecruiter
              ? 'You are the last recruiter in this session. Ending the meeting will disconnect the candidate and finalize the interview for AI analysis.'
              : 'You will leave the interview. Other recruiters and the candidate will remain in the session.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="primary" disabled={ending}>
            Cancel
          </Button>
          {isLastRecruiter ? (
            <Button
              onClick={() => handleDisconnect(true)}
              style={{ color: '#d32f2f' }}
              disabled={ending}
            >
              {ending ? 'Ending…' : 'End for Everyone'}
            </Button>
          ) : (
            <Button
              onClick={() => handleDisconnect(false)}
              style={{ color: '#d32f2f' }}
              disabled={ending}
            >
              {ending ? 'Leaving…' : 'Leave Session'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}